import React, { Dispatch, RefObject, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import styles from "./search-input.module.scss";

import { ApplicationStore } from "~/app/application.store";
import { searchChatAction, switchSearchWrapperAction } from "~/app/chat/search/search.actions";

const SearchInputComponent: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();

  const isOpenSearchWrapper: boolean = useSelector((state: ApplicationStore) => state.search.isOpenSearchWrapper);

  const [searchValue, setSearchValue]: [string | null, React.Dispatch<React.SetStateAction<string | null>>] = useState<
    string | null
  >(null);

  const ref: RefObject<HTMLInputElement> = useRef<HTMLInputElement>(null);

  const handleSearch: (query: string | null) => void = useCallback(
    (query: string | null): void => {
      dispatch(searchChatAction(query));
    },
    [dispatch]
  );

  const handleSwitchOpenSearchWrapper: (isOpen: boolean) => void = useCallback(
    isOpen => {
      dispatch(switchSearchWrapperAction(isOpen));
    },
    [dispatch]
  );

  useEffect(() => {
    const timeout: ReturnType<typeof setTimeout> = setTimeout(() => {
      handleSearch(searchValue);
    }, 500);
    return (): void => clearTimeout(timeout);
  }, [searchValue]);

  useEffect((): void => {
    if (isOpenSearchWrapper === false) {
      setSearchValue(null);
    }
  }, [isOpenSearchWrapper]);

  const handleCloseSearch: () => void = () => {
    handleSwitchOpenSearchWrapper(false);
    ref.current?.blur();
  };

  const handleChange: (value: string) => void = (value: string): void => {
    setSearchValue(value);
    if (value !== "") {
      handleSwitchOpenSearchWrapper(true);
    } else {
      handleSwitchOpenSearchWrapper(false);
    }
  };

  return (
    <div className={styles.searchWrap}>
      <div className={styles.search}>
        <input
          ref={ref}
          type="text"
          placeholder="Search"
          value={searchValue ?? ""}
          onChange={(event): void => {
            handleChange(event.target.value);
          }}
          // onClick={(): void => {
          //   if (props.isOpenSearchWrapper == false) {
          //     props.handleSwitchOpenSearchWrapper(true);
          //   }
          // }}
          onKeyDown={(event): void => {
            if (event.key === "Escape") {
              handleCloseSearch();
            }
          }}
        />
        {isOpenSearchWrapper && <button className={styles.close} onClick={(): void => handleCloseSearch()}></button>}
      </div>
    </div>
  );
};

export default SearchInputComponent;
